import { TPlan, TPlanPrice } from './types'

export enum Locale {
  ru = 'ru',
  en = 'en'
}

export const PLANS: {
  [key in TPlan]: TPlanPrice
} = {
  free: {
    id: 'free',
    title: 'price-free',
    pricePerYear: '0,00',
    pricePerMonth: '0,00'
  },
  indie: {
    id: 'indie',
    title: 'price-default',
    pricePerYear: '11.99',
    pricePerMonth: '14.99'
  },
  pro: {
    id: 'pro',
    title: 'price-expanded',
    pricePerYear: '39.99',
    pricePerMonth: '49.99'
  },
  enterprise: {
    id: 'enterprise',
    title: 'price-enterprise',
    pricePerYear: '-',
    pricePerMonth: '-'
  }
}
